var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoriskesteder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.809,3.165a.4.4,0,0,0-.4-.4H5.184a.4.4,0,0,0-.4.4V4.792C4.781,6.3,6.62,7.024,6.62,7.8s-1.839,1.51-1.839,3.012v1.61a.405.405,0,0,0,.4.4h5.223a.4.4,0,0,0,.4-.4v-1.61c0-1.493-1.791-2.144-1.791-3.012s1.791-1.51,1.791-3.023ZM10,4.781c0,.49-.334.86-.843,1.369A2.436,2.436,0,0,0,8.213,7.8a2.451,2.451,0,0,0,.952,1.661c.507.506.839.874.839,1.351v1.006H9.782L8.376,10.47a.847.847,0,0,0-1.161,0L5.809,11.822H5.587V10.816c0-.536.458-.987.9-1.424A2.343,2.343,0,0,0,7.425,7.8a2.337,2.337,0,0,0-.937-1.586c-.544-.537-.9-.926-.9-1.426V3.777H10Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoriskesteder);
export default __webpack_public_path__ + "static/media/HISTORISKE STEDER.408106ef47ac81cb3bd8569a7710aca9.svg";
export { ForwardRef as ReactComponent };